import { defineMessages } from "react-intl";

import { getDisplayName } from "../Utils/getDisplayName";
import { useFormatMessage } from "../Intl/Context";


function withAccountLocked(WrappedComponent) {
  const WithAccountLocked = props => {
    const t = useFormatMessage();
    const accountLockedError = t(intlMessages.accountLockedError);

    return (
      <WrappedComponent
        {...props}
        accountLockedErrorMessage={accountLockedError}
      />
    );
  };

  WithAccountLocked.displayName = `WithAccountLocked(${getDisplayName(WrappedComponent)})`;

  return WithAccountLocked;
}

export { withAccountLocked };

const intlMessages = defineMessages({
  accountLockedError: {
    id: "authentication.signIn.accountLockedError",
    defaultMessage: `
      Impossible de vous connecter, votre compte a été bloqué suite à un trop grand
      nombre de tentatives de connexion. Un e-mail vous a été envoyé lors du blocage de
      votre compte, merci d'utiliser le lien contenu dans ce mail afin de débloquer
      votre compte.
    `
  }
});
